// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"241":"27bf2c00","284":"d8a9fc5b","377":"718e063b","421":"79334885","798":"cccc4324"}[chunkId] + ".css";
};